import { useTranslation } from "react-i18next";
import { useRoundStore } from "../../state/roundStore.js";
import type { BetPeriod, BetSort } from "./useBetHistory.js";

export function TopFilters({
  period,
  sort,
  currency,
  onPeriod,
  onSort,
  onCurrency,
}: {
  period: BetPeriod;
  sort: BetSort;
  currency: string;
  onPeriod: (value: BetPeriod) => void;
  onSort: (value: BetSort) => void;
  onCurrency: (value: string) => void;
}) {
  const { t } = useTranslation();
  const currencies = useRoundStore((state) => state.config?.currencies);
  return (
    <div className="cx-top-filters flex flex-wrap gap-2">
      <label className="cx-field flex-1">
        {t("bets.period")}
        <select
          className="cx-input"
          value={period}
          onChange={(event) => {
            const value = event.target.value;
            if (value === "day" || value === "week" || value === "month" || value === "year") onPeriod(value);
          }}
        >
          {(["day", "week", "month", "year"] as const).map((value) => (
            <option key={value} value={value}>
              {t(`bets.periods.${value}`)}
            </option>
          ))}
        </select>
      </label>
      <label className="cx-field flex-1">
        {t("bets.sort")}
        <select
          className="cx-input"
          value={sort}
          onChange={(event) => {
            const value = event.target.value;
            if (value === "win" || value === "multiplier") onSort(value);
          }}
        >
          <option value="win">{t("bets.win")}</option>
          <option value="multiplier">{t("bets.multiplier")}</option>
        </select>
      </label>
      <label className="cx-field">
        {t("bets.currency")}
        <select className="cx-input" value={currency} onChange={(event) => onCurrency(event.target.value)}>
          {currencies?.map((value) => (
            <option key={value.code}>{value.code}</option>
          ))}
        </select>
      </label>
    </div>
  );
}
